import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation, number } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult = objectOf({
  limit: anyOf(number, nullValidation),
  active_count: number,
});
